import { gql, useMutation, useQuery } from '@apollo/client'
import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card, Button } from 'rebass/styled-components'
import { IGetFormContentInput, IGetFormContentOutput } from '../../../graphql/types/queries/forms'
import { GET_FORM_CONTENT } from '../../../graphql/queries'
import { IProperties } from '../builder/types'
import { IFormMeta } from '../builder/Builder'
import PleaseWait from '../../../components/PleaseWait'
import { FillingFormInner } from './components/FillingFormInner'
import { IOkPayloadWithError } from '../../../graphql/types/mutations/generics'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import Modal from 'styled-react-modal'

const SAVE_FORM = gql`
  mutation saveHealthCoachFormAnswers($patientId: String!, $content: String, $formMetadata: FormMetadataInput!) {
    saveHealthCoachFormAnswers(patientId: $patientId, content: $content, formMetadata: $formMetadata) {
      ok,
      customError
    }
  }
`

interface ISaveHealthCoachFormAnswersInput {
  patientId: string,
  content?: string,
  formMetadata: IFormMeta
}

interface ISaveHealthCoachFormAnswersOutput {
  saveHealthCoachFormAnswers: IOkPayloadWithError
}

interface IFillingFormProps {
  formId: string
  athenaId: string
}

export const FillingForm: React.FC<IFillingFormProps> = ({ formId, athenaId }) => {
  const navigate = useNavigate()
  const [cancelConfirmation, setCancelConfirmation] = useState(false)
  const [selectedTemplate, setSelectedTemplate] = useState<{
    template: IProperties[],
    meta: IFormMeta
  } | null>()
  const [save, { loading: saving }] = useMutation<ISaveHealthCoachFormAnswersOutput, ISaveHealthCoachFormAnswersInput>(SAVE_FORM, {
    onCompleted: e => {

      if (!!e.saveHealthCoachFormAnswers.ok) {
        toast.success(`Note added successfully`, {
          autoClose: 5000
        });
        navigate(`/patient/${athenaId}`);
      } else {
        toast.error(e.saveHealthCoachFormAnswers.customError || `An error occured`, {
          autoClose: 10000
        });
      }
    }
  })

  const { data: dataFormContent, loading: loadingFormContent, error: errorFormContent } = useQuery<IGetFormContentOutput, IGetFormContentInput>(GET_FORM_CONTENT, {
    variables: {
      formId
    },
    onCompleted: (e) => {
      setSelectedTemplate({
        meta: {
          id: e.getFormContent.id,
          name: e.getFormContent.name,
          target: e.getFormContent.target.id,
          targetName: e.getFormContent.target.target,
          version: e.getFormContent.version,
          description: e.getFormContent.description,
          basedOnTemplate: e.getFormContent.basedOnTemplate?.id || '',
          templateBuilderUpdatedAt: e.getFormContent.basedOnTemplate?.builderUpdatedAt,
          formBuilderUpdatedAt: e.getFormContent.builderUpdatedAt
        },
        template: JSON.parse(e.getFormContent.content)
      })
    }
  })

  const onCancelRequested = () => {
    setCancelConfirmation(true)
  }

  if (!!loadingFormContent) {
    return (
      <Flex flex={1} width={'100%'} justifyContent={'center'} alignItems={'center'}>
        <PleaseWait />
      </Flex>
    )
  }
  if (!dataFormContent || !selectedTemplate) {
    return (
      <Flex flex={1} width={'100%'} justifyContent={'center'} alignItems={'center'}>
      </Flex>
    )
  }
  return (
    <Flex flex={1} width={'100%'}>
      <FillingFormInner meta={selectedTemplate.meta} template={selectedTemplate.template} save={(content: string) => {
        save({
          variables: {
            patientId: athenaId,
            content,
            formMetadata: {
              id: selectedTemplate.meta.id,
              name: selectedTemplate.meta.name,
              target: selectedTemplate.meta.target,
              targetName: selectedTemplate.meta.targetName,
              version: selectedTemplate.meta.version,
              description: selectedTemplate.meta.description,
              basedOnTemplate: selectedTemplate.meta.basedOnTemplate,
            }
          }
        })
      }} saving={saving} onCancelRequested={onCancelRequested} />
      {!!cancelConfirmation && (
        <Modal
          isOpen={!!cancelConfirmation}
          onBackgroundClick={() => setCancelConfirmation(false)}
          onEscapeKeydown={() => setCancelConfirmation(false)}>
          <Box style={{ margin: '0 auto', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <Heading mb={3}>Are you sure?</Heading>
            <Text mb={4} >Press Yes to discard the form. Otherwise press No.</Text>
            
            <Flex flexDirection={'row'} justifyContent='space-between' width={'100%'}>
              <Button variant={'pink'} onClick={()=>navigate(`/patient/${athenaId}`)} mt={4} >Yes</Button>
              <Button variant={'primary'} onClick={()=>setCancelConfirmation(false)} mt={4} >No</Button>
            </Flex>
            <Box onClick={()=>setCancelConfirmation(false)} style={{ cursor: 'pointer', position: 'absolute', top: '-10px', right: '-10px', height: '34px', width: '34px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F8A294', padding: '6px', borderRadius: '50%', color: 'white' }}>
              X
            </Box>
          </Box>
        </Modal>
      )}
    </Flex>);
}